import { Injectable } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { Observable } from 'rxjs';
import { Promocao } from './../models/promocao.model';

@Injectable({
  providedIn: 'root'
})
export class PromocaoService {
  private url = 'http://189.126.197.169/node/server/index.js?service=Ebook.svc/getPromocao';
  // private url = '//services.focustextil.com.br/node/server/index.js?service=Ebook.svc/getPromocao';

  constructor(private http: HttpClient) { }

  listPromo(): Observable<Promocao[]> {
    return this.http.get<any>(this.url)
  }
}
